import { BaseClass } from './base-class';
import { BaseRepository } from '@interfaces/base-repository';
import { Site } from './site';

export class SiteGroup extends BaseClass implements BaseRepository {
    name: string;
    siteIds: string[];
  sites: Site[];
  allowOtherAddress: boolean;

    constructor()
    constructor(
      name: string,
      siteIds: string[],
      allowOtherAddress?: boolean)
    constructor(
      name?: string,
      siteIds?: string[],
      allowOtherAddress?: boolean) {
        super();

        this.name = this.trim(name);
        this.siteIds = siteIds || [];
        this.sites = [];
        this.allowOtherAddress = allowOtherAddress;
    }

    static fromObject(object: SiteGroup): SiteGroup {
        return Object.assign(new SiteGroup(), {
          ...object,
          siteIds: object.siteIds || [],
          sites: object.sites ? object.sites.map(s => Site.fromObject(s)) : []
        });
    }

    get display(): string {
        return `${this.name}`;
    }

    doesInclude(value: string): boolean {
        return this.some([this.name], value);
    }
}
